/**
 * A hint that a session probably exists, so the app knows whether the
 * boot-time refresh call is worth making.
 *
 * The refresh cookie is HttpOnly and lives on the API host, which is a
 * sibling subdomain of the front: JavaScript cannot see it, and a companion
 * cookie set by the API would have to be widened to the whole parent domain
 * to be readable here. So the front keeps its own note of "I logged in
 * here", in localStorage.
 *
 * This is a hint, not a credential. It holds no token and grants nothing: a
 * stale "yes" costs one refresh call that fails and clears it, a stale "no"
 * cannot happen because login always sets it. Its only job is to spare an
 * anonymous visit to /login a request that is known to 400.
 */
const KEY = "chronos:session";

export const hasSessionHint = (): boolean => {
	try {
		return localStorage.getItem(KEY) === "1";
	} catch {
		// Storage unavailable (private mode, blocked): assume a session might
		// exist and let the refresh call decide.
		return true;
	}
};

export const setSessionHint = (): void => {
	try {
		localStorage.setItem(KEY, "1");
	} catch {
		// Nothing to do: the app still works, it just cannot skip the call.
	}
};

export const clearSessionHint = (): void => {
	try {
		localStorage.removeItem(KEY);
	} catch {
		// See setSessionHint.
	}
};
